export default "__VITE_PUBLIC_ASSET__10d646cc__"